import { useCallback, useState } from 'react';

import { TourKeys } from '@cast/constants';
import { useWindowWidth, usePersistentState } from '@cast/utils';

import { useIsTourActive } from 'core/tour-v2/hooks/useIsTourActive';
import { SecondarySidebarState } from 'main-layout-op/_types';

import { POST_PLG_SM } from '../../_constants';

type Result = {
  state: SecondarySidebarState;
  pinned: boolean;
  expandSidebar(): void;
  pinSidebar(): void;
  collapseSidebar(): void;
};

export function useSecondarySidebarState(noSidebar: boolean): Result {
  const isTourActive = useIsTourActive(TourKeys.OpinionatedPlatform);
  const windowWidth = useWindowWidth({ enabled: !isTourActive });

  const [pinned, setPinned] = usePersistentState(
    'secondarySidebarPinned',
    !(!isTourActive && windowWidth <= POST_PLG_SM), // Collapse sidebar on small screens
    'session'
  );
  const [state, setState] = useState<SecondarySidebarState>(
    noSidebar ? 'collapsed' : pinned ? 'pinned' : 'collapsed'
  );

  const pinSidebar = useCallback(() => {
    setState('pinned');
    setPinned(true);
  }, [setPinned]);

  const collapseSidebar = useCallback(() => {
    setState('collapsed');
    setPinned(false);
  }, [setPinned]);

  const expandSidebar = useCallback(() => {
    setState('expanded');
  }, []);

  return {
    state: isTourActive ? 'pinned' : state,
    pinned: isTourActive ? true : pinned,
    pinSidebar,
    collapseSidebar,
    expandSidebar,
  };
}
